// src/views/Pricing/PricingPage.jsx
//
// El catálogo de tarifas: cuánto cuesta cada cosa en coins, y un FAQ de
// facturación. No es un ajuste, así que no está en configuración; y no es un
// objeto de la app, así que no es un destino del rail.
//
// La URL no cambia —sigue siendo /user/pricing— porque lo que se retiró aquí no
// es la vista, es la carcasa: `Profile.jsx` existía solo para servir esta
// pantalla y arrastraba medio millar de líneas del perfil viejo, ya inalcanzable,
// más una barra lateral con enlaces a secciones que ya no existen.
//
// Ahora vive dentro del AppShell, así que conserva el rail y desde aquí se puede
// ir a cualquier sitio. Antes era una pantalla sin salida salvo un "Back to Home".
import React from 'react';
import AppBackdrop from '../../components/ui/AppBackdrop';
import PricingView from '../Profile/PricingView';

export default function PricingPage() {
  return (
    <section className="relative min-h-screen overflow-hidden bg-gray-950 text-white">
      <AppBackdrop />
      {/* El desplazamiento sale de --rail-w: el rail se pliega y la vista lo sigue. */}
      <div className="relative z-10 rail-pad p-6 md:p-8">
        <PricingView />
      </div>
    </section>
  );
}
